import { IconSize } from '.';

export const iconSizes: Record<IconSize, string> = {
  lg: '52px',
  md: '40px',
  sm: '32px',
  xl: '75px',
  xs: '24px',
  xxl: '132px',
  xxs: '16px',
  xxxs: '8px',
};
